<template>
  <div class="d-flex flex-sm-column flex-md-column flex-lg-row flex-xl-row align-items-center align-content-center justify-content-center" :class="messageClass">{{ $t(message) }}
    <div class="position-absolute arrow-down"></div>
  </div>
</template>

<script>
import {defineComponent} from "vue";
import './message.scss';


export default defineComponent({
  name: 'MessageComponent',
  props: {
    message: {
      type: String,
      default: ''
    },
    messageClass: {
      type: String
    }
  },

  data() {
    return {

    }
  }
})
</script>

<style>

</style>